// Get selected elements and return an object with each element id as key and element as value
const getSelectedElements = (selectedFlatRows) => {
    return selectedFlatRows.reduce((acc, current) => (acc[current.original.object.id] = current.original.object, acc), {})
}

export { getSelectedElements }